/**
 * canvas-engine/presets/presetData/index.js
 *
 * Aggregated re-exports of the transcribed default-look VALUES (Task 3.1).
 * DATA only — no React, no rendering. Decomposition adapters (Task 3.2/3.3)
 * import from here to read per-section-type default content + style values.
 *
 * ZERO-REUSE: every value originates from the transcribed presetData modules
 * (not imported from the existing template-builder).
 */

export {
  EDUCATION_PRESETS,
  educationImages,
  educationTheme,
  educationSectionPresets,
} from './educationPresets';

export {
  WAAS_PRESETS,
  waasImages,
  waasTheme,
  waasSectionPresets,
} from './waasPresets';

export {
  FLEX_OFFICE_PRESETS,
  flexOfficeImages,
  flexOfficeTheme,
  flexOfficeSectionPresets,
} from './flexOfficePresets';

export {
  RETAIL_PRESETS,
  retailImages,
  retailTheme,
  retailSectionPresets,
} from './retailPresets';

export { GENERIC_PRESETS, genericSectionPresets } from './genericPresets';

export { CHROME_PRESETS } from './chromePresets';

export { CUSTOM_PRESETS, customStartersByDomain } from './customPresets';

export { DYNAMIC_PRESETS } from './dynamicPresets';

// Convenience: family-keyed map of section presets for the Section_Library.
export const PRESET_DATA_BY_DOMAIN = {
  education: 'EDUCATION_PRESETS',
  waas: 'WAAS_PRESETS',
  flexOffice: 'FLEX_OFFICE_PRESETS',
  retail: 'RETAIL_PRESETS',
  generic: 'GENERIC_PRESETS',
};
